export function defined(x) {
    return x !== undefined;
}
//# sourceMappingURL=defined.js.map